<template>
  <span class="leaf-score-meter">
    <ScoreLeafIcon
      v-for="(leafType, i) in scoreLeafTypeList"
      :key="i"
      :size="iconSize"
      class="leaf-score-meter__icon"
      :type="leafType"
    />
  </span>
</template>

<script lang="ts">
import ScoreLeafIcon from '@/core/components/shared/icons/ScoreLeaf.icon.vue';

export default defineNuxtComponent({
  components: {
    ScoreLeafIcon,
  },
  props: {
    score: { type: Number, required: true },
    max: { type: Number, default: 5 },
    iconSize: { type: Number, default: 24 },
  },
  setup(props) {
    const scoreLeafTypeList: string[] = [];

    let score = props.score;

    for (let i = 1; i <= props.max; i++) {
      if (score >= 1) {
        scoreLeafTypeList.push('full');
        score--;
      } else if (score > 0) {
        scoreLeafTypeList.push('half');
        score = 0;
      } else {
        scoreLeafTypeList.push('empty');
      }
    }

    return {
      scoreLeafTypeList
    }
  }
});
</script>

<style lang="scss" scoped>
.leaf-score-meter {
  @apply flex;
  @apply flex-row;
}
</style>
